const IMAGE_HEIGHTS = {
  SMALL: 338,
  MEDIUM: 432,
  LARGE_UP: 542,
};

export { IMAGE_HEIGHTS };
